import { useCallback } from 'react';

import { useAddClickButtonGtag } from '@/hooks/useGtag.hook';

export function useFaqTracking() {
  const track = useAddClickButtonGtag({
    label: 'neo-faq',
    position: 'main_content',
  });

  return useCallback(
    (key: string, isOpening: boolean) => {
      track(isOpening ? `open_${key}` : `toggle-close_${key}`);
    },
    [track],
  );
}
